import { MouseEventHandler } from "react";
import { useDispatch } from "react-redux";

import { CaseAdmin } from "pwapi";

import { uploadAdminCaseDocument } from "shared/actions/admin/adminDocumentsActions";
import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "store/hooks";

import DocumentsForm from "./DocumentsForm";
import { getAttachToCaseReportforApi } from "./editDocumentsFormUtils";

type UploadDocumentsFormProps = {
  adminCase?: CaseAdminDetail;
  onClose: MouseEventHandler<HTMLButtonElement>;
  orderId?: number | string;
};

const UploadDocumentsForm = ({
  onClose,
  adminCase,
  orderId,
}: UploadDocumentsFormProps) => {
  const dispatch = useDispatch();
  const useMergeCaseReportWorkflow = useAppSelector((state) =>
    selectFeatureFlag(state, "useMergeCaseReportWorkflow")
  );

  const handleOnSubmit = (values: any) => {
    const attachToReport = getAttachToCaseReportforApi(
      values.attach_to_case_report,
      useMergeCaseReportWorkflow,
      values.category
    );
    const submitForm = new FormData();
    submitForm.append("file_uploaded", values.file);
    orderId && submitForm.append("lab_order_id", `${orderId}`);
    values.case?.id && submitForm.append("case_id", `${values.case.id}`);
    values.category && submitForm.append("category", values.category);
    attachToReport &&
      submitForm.append("attach_to_case_report", attachToReport);
    submitForm.append("name", values.name);

    dispatch(uploadAdminCaseDocument(submitForm, onClose, values.case));
  };

  return (
    <DocumentsForm
      document={{
        case: adminCase as CaseAdmin,
        name: "",
        //@ts-ignore
        category: undefined,
        attach_to_case_report: undefined,
      }}
      onSubmit={handleOnSubmit}
      onClose={onClose}
      isUploading
      hasFlatCase={!!adminCase}
    />
  );
};

export default UploadDocumentsForm;
